import * as React from 'react'
import { Helmet } from 'react-helmet'
import { withPrefix } from 'gatsby'
//import { MDXrenderer } from 'gatsby-plugin-mdx'
// import { ParallaxProvider, ParallaxBanner } from 'react-scroll-parallax'
import Hero from './../components/hero/hero'
import HeroQuote from './../components/hero/hero-quote'
import HeroVideos from './../components/hero/hero-videos'
import Region from './../components/regions/regional-overview.js'
import Title from './../components/title/title'
import Interactive from './../components/graphics/interactive'
import Zoomable from './../components/graphics/zoomable'
import SelectReport from './../components/downloads/selection'
import YouTubeVideo from '../components/video/embed-video'
import ShowModal from '../components/modal/modal'
import ShowModalInfog from '../components/modal/modalinfographic.js'
import DownloadPub from '../components/downloads/publications'
import 'bootstrap/dist/css/bootstrap.min.css'
import 'bootstrap/dist/js/bootstrap.min.js'
import '@popperjs/core/dist/umd/popper.min.js'
import './../style.scss'
// import AppBarNoMenu from './../components/appbarextended/appbarwithoutmenu'
// import ExtendedCountdown from './../components/countdown/extendedcountdown'
// import { darkBlue } from './../assets/scss/variables.module.scss'
//import AppBarMenu from './../components/appbarextended/appbarwithmenu'
import logo from './../images/IDMC_logo_white.svg'
//import socialmediaimage from './../images/grid2022_cover.jpg'
import JSONData from './../content/jsonfile.json'
// import VisibilitySensor from 'react-visibility-sensor'
import Footer from '../components/hero/footer'
import PictureAsPdfIconOutlined from '@mui/icons-material/PictureAsPdfOutlined'


// import coverImage from 'https://www.internal-displacement.org/sites/default/files/GRID22_cover_img_edited%202.jpg'
// import scrollTo from 'gatsby-plugin-smoothscroll'
import Fade from 'react-reveal/Fade'
// import { StaticImage } from 'gatsby-plugin-image'
import Container from '@mui/material/Container'
import Typography from '@mui/material/Typography'

import Accordion from '@mui/material/Accordion'
import AccordionSummary from '@mui/material/AccordionSummary'
import AccordionDetails from '@mui/material/AccordionDetails'
import ExpandMoreIcon from '@mui/icons-material/ExpandMore'

import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined'
import Tooltip from '@mui/material/Tooltip'

// import GlobalMap from './../images/svg/globalmap2021.svg'
//G6_ND_25_2021RGB2Spiral-01
import Spiral from './../images/svg/G6_ND_25_2021RGB2Spiral-01 - Copy.svg'
import SpiralMobile from './../images/mobile_png/G6_ND_25_2021RGB2Spiral.jpg'
import SpiralDld from './../images/downloadable/GRID22-25-countries.png'

// import Breakdown from './../images/svg/G7_ND_Breadown_ConflictDisastersRGB copy.svg'
import BreakdownMobile from './../images/mobile_png/G7_ND_Breadown_ConflictDisastersRGB.jpg'
import BreakdownMobilePortrait from './../images/mobile_png/Treegraphvertical-2.jpg'
import BreakddownDld from './../images/downloadable/GRID22-breakdown.png'

// import Age from './../images/mobile_png/G4_IDPS_Globally_2020 age groupRGB.jpg'
//G6_ND_25_2021RGB2Spiral
//import Globe_Ssa from './../images/svg/globes/displacements-region-pie-sub_saharan_africa.svg'
import Quote1 from './../images/background-images/P1_Foreword_CMYK_Iraq.jpg'
import Quote2 from './../images/background-images/P9-10_740A1478.jpg'
import Quote3 from './../images/background-images/P49-50_GettyImages-1233122089.jpg'
import Quote4 from './../images/background-images/P53_UN0570020.jpg'
//import Quote5 from './../images/background-images/P86_GettyImages-1371333006.jpg'
import Quote6 from './../images/background-images/P118_740A2125_edited.jpg'
import Quote7 from './../images/background-images/GettyImages-1236933621.jpg'
import Quote8 from './../images/background-images/P87-88_GettyImages-1234025493.jpg'

import Alexandra from './../images/spokespeople/Alexandra.jpg'
import Jan from './../images/spokespeople/Jan.jpg'
import Bina from './../images/spokespeople/Bina.jpg'
import Vicente from './../images/spokespeople/Vicente.jpg'
import Vincent from './../images/spokespeople/Vincent.jpg'
import Ivana from './../images/spokespeople/Ivana.jpg'
import Ricardo from './../images/spokespeople/Ricardo.jpg'

import globe_am from './../images/svg/globes/G1_ND_A_PerRegion_ConflictDisasters.CMYK.png'
import globe_eap from './../images/svg/globes/G1_ND_EAP_PerRegion_ConflictDisasters6RGB.png'
import globe_eca from './../images/svg/globes/G1_ND_ECA_PerRegion_ConflictDisasters5RGB.png'
import globe_mena from './../images/svg/globes/G1_ND_MENA_PerRegion_ConflictDisasters4RGB.png'
import globe_sa from './../images/svg/globes/G1_ND_SA_PerRegion_ConflictDisasters3RGB.png'
import globe_ssa from './../images/svg/globes/G1_ND_SSA_PerRegion_ConflictDisasters2RGB.png'

import map_global_svg from './../images/svg/globalmap2022-2-01.svg'
import map_global from './../images/mobile_png/GRID2022-NDs-Share.jpg'
import map_global_dld from './../images/downloadable/GRID22-global-map.png'
import map_conflict_svg from './../images/svg/GRID2022 Stock Conflict RGBlight - Simplify-01.svg'
import map_conflict from './../images/mobile_png/GRID2022-Stock-Conflict-light.jpg'
import map_conflict_dld from './../images/downloadable/GRID22-map-conflict.png'
import map_disasters_svg from './../images/svg/GRID2022 Stock Disasters RGBlight - Simplify-01.svg'
import map_disasters from './../images/mobile_png/GRID2022-Stock-Disasters-light.jpg'
import map_disasters_dld from './../images/downloadable/GRID22-map-disasters.png'
import map_youth_svg from './../images/svg/GRID2022 Stock IDPs0-24 RGBlight - Simplify-01.svg'
import map_youth from './../images/mobile_png/GRID2022-Stock-IDPs0-24-light.jpg'
import map_youth_dld from './../images/downloadable/GRID22-map-youth.png'
// import read_data_conflict from './../images/downloadable/GRID22-how-to-read-data-conflict.png'
// import read_data_disasters from './../images/downloadable/GRID22-how-to-read-data-disasters.png'

import glance_idp from './../images/mobile_png/glance-total-number-idp.jpg'
import glance_internaldisplacement from './../images/mobile_png/glance-internal-displacement.jpg'
import glance_internaldisplacement_graph from './../images/mobile_png/glance-global-nd.jpg'
import glance_totalidp_graph from './../images/mobile_png/G5_TotalIIDPS_GloballyRGB.jpg'



import cover3d from './../images/grid2022-cover3d.png'

import gridhero from './../images/grid2022_hero.jpg'
// import img_specialfeature from './../images/P91_DMA10818-comp.jpg'
import ShowModalGlance from '../components/modal/modalglance'

import { Tab, Tabs, TabList, TabPanel } from 'react-tabs'
import 'react-tabs/style/react-tabs.css'
//import ScrollSpy from 'react-ui-scrollspy'
import PubData from './../content/json-publicationslinks.json'
// import {BrowserRouter as Router} from 'react-router-dom';
// import { useSearchParams } from "react-router-dom";


// markup
const IndexPageDev = ({ data }) => {
  const read_data_conflict = 'https://www.internal-displacement.org/sites/default/files/GRID21_How-to-read-our-data_Ex1.png'
const read_data_disasters = 'https://www.internal-displacement.org/sites/default/files/GRID21_How-to-read-our-data_Ex2.png'
  //const banner =
 //   'https://www.internal-displacement.org/sites/default/files/2022-04/idmc_grid22_cover_website_150dpi.jpg'
 
  const countrylistoptions = []
  const countrylist = [
    'AFG',
    'ARM',
    'AZE',
    'BGD',
    'BIH',
    'BRA',
    'BFA',
    'BDI',
    'KHM',
    'CMR',
    'CAF',
    'TCD',
    'CHL',
    'CHN',
    'COL',
    'CYP',
    'COD',
    'ECU',
    'ETH',
    'GEO',
    'GTM',
    'HTI',
    'HND',
    'IND',
    'IDN',
    'IRQ',
    'ISR',
    'JPN',
    'LBY',
    'MDG',
    'MYS',
    'MLI',
    'MEX',
    'MOZ',
    'MMR',
    'NPL',
    'NER',
    'NGA',
    'PAK',
    'PSE',
    'PNG',
    'PHL',
    'SLV',
    'SOM',
    'SSD',
    'LKA',
    'SDN',
    'SYR',
    'TUR',
    'UGA',
    'UKR',
    'VNM',
    'YEM'
  ]

  countrylist.forEach((element, index) => {
    countrylistoptions.push({
      label: `${PubData[element][0]}`,
      value: `${element}`
    })
  })

  return (
    <>
      <main>
        <Helmet
        bodyAttributes={{
          'data-bs-spy':"scroll", 'data-bs-target':"navbarIDMC",'data-bs-offset':"150"
        }}>
          <meta charSet='utf-8' />
          <title>
            IDMC | GRID 2022 | 2022 Global Report on Internal Displacement
          </title>
          <meta
            name='description'
            content="The world’s leading source of data and analysis on the risk, scale and impacts of internal displacement"
          />{' '}
          <meta name='twitter:card' content='summary_large_image' />
          <meta name='twitter:site' content='@IDMC_Geneva' />
          <meta
            name='twitter:title'
            content='2022 Global Report on Internal Displacement'
          />
          <meta
            name='twitter:image'
            content='https://www.internal-displacement.org/sites/default/files/styles/social_media_style/public/2022-05/grid2022_cover.jpg?itok=ui5O8tmW'
          />
          <meta
            property='og:title'
            content='2022 Global Report on Internal Displacement'
          />
          <meta property='og:type' content='article' />
          <meta property='og:image' content='https://www.internal-displacement.org/sites/default/files/2022-05/grid2022_cover.jpg' />
          {/* <link
            rel='canonical'
            href='https://internal-displacement.org/global-report/grid2022/'
          /> */}
          <script src={withPrefix('tooltip.js?v2.3.3')} type='text/javascript' defer/>
          {/* <script src={withPrefix('scrollspy.js')} type='text/javascript' /> */}
        </Helmet>
        
        <title>IDMC | GRID 2022 </title>
        {/* <AppBarMenu /> */}
        <div>
        <Hero
          imageUrl={gridhero}
          id='hero2'
          txtColor='#ffffff'
          bgColor='#0a3758'
          bgOpacity='0.3'
          copyright='© Illustration by Matt Murphy, April 2022'
        >
          <Container maxWidth='sm'>
            <img src={logo} width='199px' alt='IDMC logo' />
            <h1 className='mt-5'>
              Global Report on Internal Displacement 2022
            </h1>
            <p>
            IDMC's Global Report on Internal Displacement (GRID) is the world’s leading source of data and analysis on internal displacement. This year's edition includes a special focus on internally displaced children and youth. 
            </p>
            <p>
              <a href='#part1' className='whitetext'>
                Part 1
              </a>{' '}
              presents updated data and analysis of internal displacement at the
              global level. Data and contextual updates are included in the
              regional overviews and country spotlights.
            </p>
            <p>
              <a href='#part2' className='whitetext'>
                Part 2
              </a>{' '}
              explores the impacts of displacement on children and youth, so
              often invisible in displacement data, while highlighting promising
              initiatives that address some of their challenges.
            </p>
          </Container>
        </Hero>
        <nav className="navbar navbar-expand-lg navbar-dark fixed-top pt-0" id="navbarIDMC"  style={{ flexDirection: 'column'}}>
          <div className="container-fluid mb-2" style={{background:'#008dc9'}}>
          <div className="container" style={{justifyContent:'center', display:'flex'}}>
          <a className="nav-link" href="https://www.internal-displacement.org/global-report/" >Previous editions</a>{" "} <a
                  className="nav-link"
                  href={withPrefix("spanish")}
                >
                  Español
                </a>{" "}  <a
                  className="nav-link"
                  href={withPrefix("french")}
                >
                  Français
                </a>{" "}  <a
                  className="nav-link"
                  href="https://www.internal-displacement.org/sites/default/files/2022-10/IDMC_GRID%202022_AR_LowRes.pdf"  style={{direction:"rtl"}}
                >
                  العربية 
                </a>
          </div></div>
  <div className="container">
  <a className="navbar-brand" href="https://www.internal-displacement.org">&lt; Back to IDMC website</a>
    <button className="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarSupportedContent" aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
      <span className="navbar-toggler-icon"></span>
    </button>
    <div className="collapse navbar-collapse" id="navbarSupportedContent">
      <ul className="nav navbar-nav me-auto ms-lg-auto mb-2 mb-lg-0">
        <li className="nav-item">
          <a className="nav-link" href="#at-a-glance" >At a glance</a>
        </li>
        {/* <li className="nav-item">
          <a className="nav-link" href="#">Link</a>
        </li> */}
        <li className="nav-item dropdown">
          <a className="nav-link dropdown-toggle" href="#part1" id="navbarDropdown" role="button" data-bs-toggle="dropdown" aria-expanded="true">
          Part 1: The global picture
          </a>
          <ul className="dropdown-menu" aria-labelledby="navbarDropdown">
            <li><a className="dropdown-item" href="#part1">Part 1: The global picture</a></li>
            <li><a className="dropdown-item" href="#spiral">Top twenty-five countries with most internal displacements</a></li>
            {/* <li><hr className="dropdown-divider" /></li> */}
            <li><a className="dropdown-item" href="#breakdown">Breakdown by conflict and disaster </a></li>
            <li><a className="dropdown-item" href="#people-living-in-displacement">People living in displacement </a></li>
            <li><a className="dropdown-item" href="#regional-overviews">Regional overviews</a></li>
          </ul>
        </li>
        <li className="nav-item">
          <a className="nav-link" href="#part2" >Part 2: Children and youth</a>
        </li>
        <li className="nav-item">
          <a className="nav-link border rounded p-2" href="#download" >Download report</a>
        </li>
        <li className="nav-item">
          <a className="nav-link" href="#mediapack" >Media Pack</a>
        </li>
      </ul>
    </div>
  </div>
</nav>
        <div>
        
          <Fade>
            <Container maxWidth='lg' id='at-a-glance'>
              <Title h4='At a glance'></Title>
              <div className='row mb-3'>
                
                <div className='col-md-6'>
                  <h4>Internal displacements in 2021</h4>
                  <img
                    src={glance_internaldisplacement}
                    alt='38 million internal displacement - 14.4m by conflict and violence, 23.7m by disasters'
                    style={{ maxWidth: '400px' }}
                  /><div className="d-none d-lg-block">
                   <ShowModalGlance name="At a glance - Internal displacements by conflict, violence and disasters worldwide (2012-2021)" id='glance_internaldisplacement_graph' img={glance_internaldisplacement_graph} />
                   </div>
                   <div className='d-lg-none'>
                  <Zoomable
                  src={glance_internaldisplacement_graph}
                  alt='At a glance - Internal displacements by conflict, violence and disasters worldwide (2012-2021)'
                  caption=''
                  zoom='200'
                  dld={glance_internaldisplacement_graph}
                  interact='You can interact with this infographic to see in-depth data'
                  download='Download infographic'
                />
                  </div>
                   <p className='small' style={{ color: "#636363"}}>
                    * Due to rounding, some totals may not correspond with the sum
                    of the separate figures.
                  </p>
                </div>
                <div className='col-md-6'>
                  <h4>Total number of IDPs</h4>
                  <img
                    src={glance_idp}
                    alt='59.1 million internally displaced people - 53.2m by conflict and violence, 5.9m by disasters'
                    style={{ maxWidth: '400px' }}
                  /> <div className="d-none d-lg-block">
                  <ShowModalGlance name="At a glance - Total number of IDPs worldwide at year end (2012-2021)" id='glance_totalidp_graph' img={glance_totalidp_graph} />
                  </div>
                  <div className='d-lg-none'>
                  <Zoomable
                  src={glance_totalidp_graph}
                  alt='At a glance - Total number of IDPs worldwide at year end (2012-2021)'
                  caption=''
                  zoom='200'
                  dld={glance_totalidp_graph}
                  interact='You can interact with this infographic to see in-depth data'
                  download='Download infographic'
                />
                  </div>
                </div>
                <div className='col-md-12'><h4>How to read our data</h4></div>
                <div className='col-md-6'>

                   <ShowModalGlance name="How to read our data - conflict and violence" id='read_data_conflict' img={read_data_conflict} />


                </div>
                <div className='col-md-6'>
                  <ShowModalGlance name="How to read our data - disasters" id='read_data_disasters' img={read_data_disasters} />
                </div>
              </div>
              <div className='row mb-3'>
              <div className='col-md-6'>
              <YouTubeVideo youtubeId='AvJKuUM3vjk'></YouTubeVideo>
              </div><div className='col-md-6'> <YouTubeVideo youtubeId='BHRI-0suJhw'></YouTubeVideo></div></div>
            </Container>
          </Fade>

            <div id='part1' className='section'>
              <Fade>
                <Container maxWidth='lg'>
                  <Title
                    h2='Part 1: the global picture'
                    h3='Internal displacement in 2021'
                  ></Title>
                  <p>
                    Conflict, violence and disasters triggered{' '}
                    <strong>38 million internal displacements</strong> across
                    141 countries and territories in 2021, the second highest
                    annual figure in a decade after 2020's record-breaking year
                    for disaster displacement. Conflict and violence triggered
                    14.4 million movements, an increase of almost 50 per cent on
                    the year before.
                  </p>

                  {/* <Zoomable
                  src={map_global}
                  alt='Countries and territories with most new displacements in 2021'
                  caption='Countries and territories with most new displacements in 2021'
                  zoom='200'
                  dld='/'
                  interact='You can interact with this infographic to see in-depth data'
                  download='Download infographic'
                /> */}</Container>
<Container >
                  <Interactive
                    svg={map_global_svg}
                    png={map_global}
                    id='globalmap'
                    tooltip_id='globaltooltip'
                    dld={map_global_dld}
                    caption='Countries and territories with most internal displacements in 2021'
                    alt='Countries and territories with most internal displacements in 2021'
                    interact='You can interact with this infographic to see in-depth data'
                    download='Download infographic'
                    name='Global map'
                    dropdown={[
                      "AFG",
                      "AGO",
                      "AUS",
                      "BGD",
                      "BRA",
                      "BFA",
                      "BDI",
                      "CMR",
                      "CAN",
                      "CAF",
                      "TCD",
                      "CHN",
                      "COL",
                      "CUB",
                      "COD",
                      "SLV",
                      "ETH",
                      "GRC",
                      "HTI",
                      "IND",
                      "IDN",
                      "IRN",
                      "IRQ",
                      "KEN",
                      "KGZ",
                      "MYS",
                      "MLI",
                      "MEX",
                      "MOZ",
                      "MMR",
                      "NPL",
                      "NLD",
                      "NER",
                      "NGA",
                      "PAK",
                      "PSE",
                      "PHL",
                      "SOM",
                      "SSD",
                      "LKA",
                      "VCT",
                      "SDN",
                      "SYR",
                      "TZA",
                      "TUR",
                      "UGA",
                      "USA",
                      "VEN",
                      "VNM",
                      "YEM"
                      ]}
                  />
                </Container>
              </Fade>
              <HeroQuote
                imageUrl={Quote6}
                id='quote-6'
                txtColor='#ffffff'
                bgColor='#0a3758'
                bgOpacity='0'
                copyright='A young girl currently residing in Tillaberi, Niger, was able to reconnect with her classmates and peers after receiving psychosocial support to help deal with her own experiences with displacement. © Tom Peyre-Costa/NRC, April 2022.'
              ></HeroQuote>
              <Fade>
                <>
                  <Container maxWidth='lg' id='spiral'>
                    <Title h4='Top twenty-five countries with most internal displacements'></Title>
                  </Container>{' '}
                  <Container maxWidth='lg'>
                    <Interactive
                      svg={Spiral}
                      png={SpiralMobile}
                      id='spiral'
                      tooltip_id='sunbursttooltip'
                      dld={SpiralDld}
                      caption='Twenty five countries and territories with most internal displacements in 2021'
                      alt='Twenty five countries and territories with most internal displacements in 2021'
                      interact='You can interact with this infographic to see in-depth data'
                      download='Download infographic'
                      name='Spiral'
                      dropdown={[
                        "AFG",
                        "BFA",
                        "BRA",
                        "CAF",
                        "CHN",
                        "COD",
                        "CUB",
                        "ETH",
                        "HTI",
                        "IDN",
                        "IND",
                        "MLI",
                        "MMR",
                        "MOZ",
                        "NER",
                        "NGA",
                        "PHL",
                        "SDN",
                        "SLV",
                        "SOM",
                        "SSD",
                        "SYR",
                        "USA",
                        "VNM",
                        "YEM"
                        ]}
                    />
                  </Container>
                </>
              </Fade>
              <HeroQuote
                imageUrl={Quote3}
                id='quote-3'
                txtColor='#ffffff'
                bgColor='#0a3758'
                bgOpacity='0'
                copyright='Palestinians seen sheltering in tents they set up amongst the rubble in Gaza. © Mustafa Hassona /Anadolu Agency via Getty Image, May 2021.'
              ></HeroQuote>
              <Fade>
                <>
                  <Container className='mt-5' maxWidth='lg' id='breakdown'>
                    <Title h4='Breakdown by conflict and disaster'></Title>
                  </Container>{' '}
                  <Container className='showLandscape' maxWidth='lg'>
                  <Zoomable
                      
                      src={BreakdownMobile}
                      id='breakdowngraphic'
                      tooltip_id=''
                      dld={BreakddownDld}
                      caption='Internal displacements breakdown by conflict, violence and disasters in 2021'
                      alt='Internal displacements breakdown by conflict, violence and disasters in 2021'
                      interact='You can interact with this infographic to see in-depth data'
                      download='Download infographic'
                      zoom={200}
                      name='breakdown'
                    />
                  </Container>
                  <Container className='showPortrait' maxWidth='lg'>
                  
                    <Zoomable
                     
                      src={BreakdownMobilePortrait}
                      id='breakdownPortrait'
                      tooltip_id=''
                      dld={BreakddownDld}
                      caption='Internal displacements breakdown by conflict, violence and disasters in 2021'
                      alt='Internal displacements breakdown by conflict, violence and disasters in 2021'
                      interact='You can interact with this infographic to see in-depth data'
                      download='Download infographic'
                      zoom={200}
                      name='breakdown'
                    />
                  </Container>
                </>
              </Fade>
              <HeroQuote
                imageUrl={Quote2}
                id='quote-2'
                txtColor='#ffffff'
                bgColor='#0a3758'
                bgOpacity='0'
                copyright='Mbela displacement camp, Central African Republic. © Tom Peyre-Costa/NRC, February 2021'
              ></HeroQuote>
              <Fade>
                <Container
                  className='mt-5'
                  
                  id='people-living-in-displacement'
                >
                  <Title h4='People living in displacement'></Title>
                  <p>
                    There were <strong>59.1 million</strong> internally
                    displaced people across the world at the end of 2021,{' '}
                    <span className='orange'>
                      53.2 million as a result of conflict and violence
                    </span>
                    , and{' '}
                    <span className='blue'>
                      5.9 million as a result of disasters
                    </span>
                    .
                  </p>
                </Container>
                {/* <Container className='mt-5'>
                  <h4>Conflict</h4>
                </Container>
                <Container >
                  <Interactive
                    svg={map_conflict_svg}
                    png={map_conflict}
                    id='idpconflict'
                    tooltip_id='conflicttooltip'
                    dld={map_conflict_dld}
                    caption='Total number of IDPs by conflict and violence as of 31 December 2021'
                    alt='Total number of IDPs by conflict and violence as of 31 December 2021'
                    interact='You can interact with this infographic to see in-depth data'
                    download='Download infographic'
                    name='Map - conflict'
                    dropdown={[
                      "AFG",
                      "BFA",
                      "COD",
                      "COL",
                      "ETH",
                      "NGA",
                      "SDN",
                      "SOM",
                      "SYR",
                      "YEM"
                      ]}
                  />
                </Container>
                <Container className='mt-5'>
                  <h4>Disasters</h4>
                </Container>
                <Container className='mb-5'>
                  <Interactive
                    svg={map_disasters_svg}
                    png={map_disasters}
                    id='idpdisasters'
                    tooltip_id='disasterstooltip'
                    dld={map_disasters_dld}
                    caption='People internally displaced by disasters as of 31 December 2021'
                    alt='People internally displaced by disasters as of 31 December 2021'
                    interact='You can interact with this infographic to see in-depth data'
                    download='Download infographic'
                    name='Map - disasters'
                    dropdown={[
                      "AFG",
                      "CHN",
                      "COD",
                      "ETH",
                      "HTI",
                      "IDN",
                      "MOZ",
                      "NGA",
                      "PHL",
                      "SSD"
                      ]}
                  /> */}
                  <Container className='mb-5' id="tabs">
                  <Tabs>
                  <TabList>
                    <Tab>Conflict and violence</Tab>
                    <Tab>Disasters</Tab>
                  </TabList>
                  <TabPanel>


                    <Interactive
                    svg={map_conflict_svg}
                    png={map_conflict}
                    id='idpconflict'
                    tooltip_id='conflicttooltip'
                    dld={map_conflict_dld}
                    caption='Total number of IDPs by conflict and violence as of 31 December 2021'
                    alt='Total number of IDPs by conflict and violence as of 31 December 2021'
                    interact='You can interact with this infographic to see in-depth data'
                    download='Download infographic'
                    name='Map - conflict'
                    dropdown={[
                      "AFG",
                      "BFA",
                      "COD",
                      "COL",
                      "ETH",
                      "NGA",
                      "SDN",
                      "SOM",
                      "SYR",
                      "YEM"
                      ]}
                  />
                  </TabPanel>
                  <TabPanel>

                    <Interactive
                    svg={map_disasters_svg}
                    png={map_disasters}
                    id='idpdisasters'
                    tooltip_id='disasterstooltip'
                    dld={map_disasters_dld}
                    caption='Total number of IDPs by disasters as of 31 December 2021'
                    alt='Total number of IDPs by disasters as of 31 December 2021'
                    interact='You can interact with this infographic to see in-depth data'
                    download='Download infographic'
                    name='Map - disasters'
                    dropdown={[
                      "AFG",
                      "CHN",
                      "COD",
                      "ETH",
                      "HTI",
                      "IDN",
                      "MOZ",
                      "NGA",
                      "PHL",
                      "SSD"
                      ]}
                  />
                  </TabPanel>
                </Tabs>
                </Container>
              </Fade>
              {/* <Fade>
              <Container className='mt-5' maxWidth='md' id='impacts'>
                <Title h4='The economic and social impacts of displacement'></Title>
                <p>
                  We estimate that the economic impact of internal displacement
                  worldwide was more than $21 billion in 2021. The figure
                  includes the cost of providing every IDP with support for
                  their housing, education, health and security, and accounts
                  for their loss of income for one year of displacement. It is
                  based on information published in humanitarian response plans
                  and only considers the cost of covering IDPs’ basic needs and
                  immediate losses.
                </p>
                <p>
                  It does not include the economic impacts of displacement on
                  host communities or IDPs in the process of returning. Nor does
                  it account for investments made by governments or development
                  stakeholders to address the longer-term consequences of
                  displacement. Put simply, when it comes to understanding the
                  financial burden of the phenomenon, the figure is just the tip
                  of the iceberg.
                </p>
                <YouTubeVideo youtubeId='KcgYNEpuUV4' />
              </Container>
            </Fade>
            <Fade>
              <Container maxWidth='md' id='age'>
                <Title h4='Breakdown of IDPs by age group'></Title>
                <Zoomable
                  src={Age}
                  alt='Estimated number of people of different age groups living in internal displacement as a result of conflict, violence and disasters globally at the end of 2021'
                  caption='Estimated number of people of different age groups living in internal displacement as a result of conflict, violence and disasters globally at the end of 2021'
                  zoom='200'
                  dld='/'
                  interact='You can interact with this infographic to see in-depth data'
                  download='Download infographic'
                />
              </Container>
            </Fade> */}

<HeroQuote
                imageUrl={Quote4}
                id='quote-4'
                txtColor='#ffffff'
                bgColor='#0a3758'
                bgOpacity='0'
                copyright='Typhoon Rai triggered the largest number of disaster displacements in 2021. Pictured, a boy sitting in the debris of his broken home. © UNICEF/ UN0570020/Hogsholt, December 2021.'
              ></HeroQuote>
              
              <Container maxWidth='lg' id='regional-overviews'>
                <Title h4='Regional overviews'></Title>
                <p>
                Sub-Saharan Africa accounted for more than 80 per cent of all internal displacements triggered by conflict and violence worldwide in 2021. The regional total was 4.7 million higher than the figure for the previous year, driven mostly by conflict in Ethiopia, the Democratic Republic of the Congo (DRC), Burkina Faso, Somalia and the Central African Republic (CAR).
                </p>
                <p>
                Most of the new and repeated displacements triggered by disasters in 2021 were recorded in the  Asia and  Pacific regions, which together accounted for about 80 per cent of the total. Tropical cyclones, monsoon rains and floods hit highly exposed areas that are home to millions of people. The most affected countries were China, the Philippines and India.
                </p>

                <Region
                  Json={JSONData}
                  regionId='ssa'
                  svg={globe_ssa}
                  hidden={[
                    'Disasters triggered 2.6 million displacements, fewer than in 2020. Floods were less intense and widespread, accounting for about 60 per cent of the total, compared with 98 per cent the previous year. Volcanic activity, drought, storms, earthquakes, and wildfires accounted for the remaining 40 per cent. Some disasters displaced people in areas already coping with the impacts of conflicts and violence, and these overlapping crises pushed millions of people into acute food insecurity. Many countries recorded their worst ever levels, including famine conditions.',
                    'There were 27.2 million people living in internal displacement across the region as a result of conflict, violence and disasters at the end of the year, an increase of 3.1 million on the figure for 2020. IDPs came under attack in several countries, forcing some to flee again, increasing their vulnerability and impeding humanitarian access. These concerning trends are a reminder of the urgent need to scale up efforts to address and reduce internal displacement in the region.',
                    'A number of countries have adopted promising practices. These include the life-saving evacuation of people before disasters strike, and better tracking of the duration of displacement with the aim of providing more tailored responses for those affected. Government-led return operations also took place in at least five countries. These positive developments, however, face a number of challenges.'
                  ]}
                >
                  <p>
                    Conflict and violence triggered 11.6 million internal
                    displacements in sub-Saharan Africa in 2021, the highest
                    figure ever recorded for the region. New waves of violence
                    in eastern Africa and escalating tensions and conflict in
                    the central Sahel and Lake Chad regions accounted for most
                    of the movements, but violence also led to displacement in
                    southern and central Africa, most notably in CAR, DRC and Mozambique. Foreign military activity also
                    influenced displacement and return trends in a number of
                    countries.
                  </p>
                </Region>
                <Region
                  Json={JSONData}
                  regionId='mena'
                  svg={globe_mena}
                  hidden={[
                    'Disasters also triggered fewer internal displacements in 2021 at 233,000, the lowest figure since 2018. Floods accounted for most at 178,000, followed by earthquakes and storms. The trend toward lower figures, however, should be read with caution. The region was affected by severe drought during the year, which caused water scarcity and wildfires from Algeria to Iran, but no countries were monitoring associated displacement systematically, which means the overall figures are conservative. As of the end of the year, around 49,000 people were living in displacement as a result of disasters across the region.'
                  ]}
                >
                  <p>
                    Conflict and violence triggered one million internal
                    displacements in the Middle East and North Africa (MENA) in
                    2021, less than half of the 2.1 million recorded the
                    previous year and the lowest figure for the region in a
                    decade. The decrease was mainly the result of de-escalating conflict in Iraq, Libya and Syria. These countries
                    continued to experience instability, however, and violence
                    increased in Yemen. Conflict also reignited in Gaza in May,
                    triggering more than 117,000 displacements, and violence led
                    to small-scale displacements in Lebanon and Israel. Across
                    the region as a whole, the number of people living in
                    displacement at the end of the year as a result of conflict
                    and violence was largely unchanged from 2020 at 12.3 million.
                  </p>
                </Region>
                <Region
                  Json={JSONData}
                  regionId='eap'
                  svg={globe_eap}
                  hidden={[
                    'The effects of La Niña manifested across different countries for the second year in a row. Storms hit the South Pacific and East and South-East Asia, triggering more than eight million displacements, the vast majority in the form of pre-emptive evacuations. Floods prompted around 5.3 million. Flooding was particularly intense in China, where one event in Henan province in July triggered around 1.5 million displacements.',
                    'Conflict and violence led to 626,000 internal displacements across the region, three times the figure for 2020 and the highest since 2017. This was mostly the result of escalating conflict in Myanmar, particularly after the military takeover in February. Around 448,000 displacements were recorded, the highest figure ever for the country but still a conservative estimate. The conflict also overlapped with disasters, further aggravating the humanitarian situation. About 2.8 million people were living in internal displacement in East Asia and the Pacific as of the end of the year, 896,000 of them as a result of conflict and violence.'
                  ]}
                >
                  <p>
                    Disasters triggered 13.7 million internal displacements in
                    East Asia and the Pacific in 2021, the highest figure since
                    2016 and above the annual average for the last decade of
                    11.6 million. As in previous years, the region accounted for
                    the majority of disaster displacements recorded worldwide.
                    It is home to most of the world’s population, many of whom
                    live in areas prone to a wide range of hazards including
                    storms, floods, earthquakes and volcanic eruptions.
                  </p>
                </Region>
                <Region
                  Json={JSONData}
                  regionId='sa'
                  svg={globe_sa}
                  hidden={[
                    'Conflict and violence also accounted for more than 736,000 displacements, the vast majority of which took place in Afghanistan. As US and NATO troops began their final withdrawal and the Taliban clashed with government forces, insecurity and deteriorating humanitarian conditions triggered 723,000, the highest figure ever recorded for the country.',
                    'Around 6.9 million people were living in internal displacement across the region at the end of the year, 5.4 million as a result of conflict and violence and 1.5 million as a result of disasters.'
                  ]}
                >
                  <p>
                    Disasters trigger most of the internal displacement that
                    takes place in South Asia each year, and 2021 was no
                    exception. Nearly 5.3 million disaster displacements were
                    recorded during the year, a relatively high figure globally
                    but lower than the region’s decade average of 6.2 million.
                    The decrease was partly the result of a weaker monsoon
                    season.
                  </p>
                </Region>
                <Region
                  Json={JSONData}
                  regionId='am'
                  svg={globe_am}
                  hidden={[
                    'Conflict and violence triggered 381,000 displacements, mostly in Colombia and Central America, and a surge in criminal violence led to the highest figure ever recorded for Haiti. We also obtained data on displacement due to violence in Brazil for the first time, but here as elsewhere in the region the information compiled is unlikely to reflect the full reality as in many countries this type of displacement is not collected systematically.'
                  ]}
                >
                  <p>
                  Disasters were the main trigger of internal displacements in the Americas in 2021, accounting for nearly 1.7 million, more than half of which were the result of storms and floods. The region was also significantly affected by wildfires and geophysical hazards. The availability and accessibility of data vary significantly between countries, which plays a role in the trends discussed below. Smaller-scale disasters tend to go unreported, but they should not be ignored given their impacts on local communities, particularly in Latin America and the Caribbean.
                  </p>
                </Region>
                <Region
                  Json={JSONData}
                  regionId='eca'
                  svg={globe_eca}
                  hidden={[
                    'Violence prompted at least 61,000 internal displacements, the highest figure for the region since 2016. Two days of border clashes between Kyrgyzstan and Tajikistan accounted for 56,000 or just over 90 per cent of the total. Very few displacements were recorded in Ukraine in 2021, but Russia’s military offensive in February 2022 has led Ukraine to become the largest and most rapidly evolving internal displacement situation in the world.'
                  ]}
                >
                  <p>
                    Disasters triggered 276,000 internal displacements in Europe
                    and Central Asia in 2021. The most significant included
                    wildfires in the Mediterranean, storms and flooding in
                    western and central Europe and a volcanic eruption in
                    Spain’s Canary Islands. 
                  </p>
                </Region>
              </Container>
              {/* <Fade bottom>
              <Container
                className='p-3 mt-5'
                maxWidth={false}
                style={{ backgroundColor: '#dee2e6' }}
              >
                <Container
                  maxWidth='md'
                  id='covid19'
                  className='border p-3 my-5'
                >
                  <Title
                    h3='Special feature'
                    h4='COVID-19: an added burden on the precarious lives of IDPs'
                  ></Title>
                  <div className='row'>
                    <div className='col-md-7'>
                      <p>
                        Covid-19 continued to affect people and economies across
                        the world in 2021 and had negative impacts on IDPs’
                        lives. Comprehensive data is lacking, but several
                        studies and programme insights confirm that the pandemic
                        was uniquely threatening to people on the move. Rather
                        than acting as a leveller, it has aggravated structural
                        inequities and vulnerabilities.
                      </p>
                      <p>
                        It tends to be difficult to disentangle cause and effect
                        and identify whether the pandemic caused, prolonged or
                        worsened a particular crisis. Coming at a time when the
                        world has more IDPs than ever before, however, it has
                        without question made the lives of millions on the move
                        even more precarious. As countries continued lockdown
                        measures and other restrictions to fight the spread of
                        the virus, IDPs felt the consequences on their income,
                        food security, basic services and ability to return to
                        their homes or move onwards to safe havens.
                      </p>
                    </div>
                    <div className='col-md-5'>
                      <img
                        src={img_specialfeature}
                        alt='Young boy wearing a mask'
                        style={{ width: '100%' }}
                      />
                    </div>
                  </div>

                  <p>
                    <DownloadPub name='covid' suffix='Download'></DownloadPub>
                  </p>
                </Container>
              </Container>
            </Fade> */}
            
              <Container maxWidth='lg'>
                <p>
                  <DownloadPub name='part1' suffix='Download' />
                </p>
              </Container>
              <HeroQuote
                imageUrl={Quote1}
                id='quote-1'
                txtColor='#ffffff'
                bgColor='#0a3758'
                bgOpacity='0.3'
                copyright='A young girl makes a drawing from inside a camp for displaced people in Northern Iraq. © Beate Simarud/NRC, October 2021.'
              >
                <p className='large text-center'>
                  "Children and young people are agents of change. Recognising
                  them as such is vital to protect development gains and reduce
                  the risk of future crises. Preparing the world of tomorrow
                  must start with their active participation and leadership."
                </p>
                <p>Alexandra Bilak, Director, IDMC</p>
              </HeroQuote>
            </div>
            <>
              <Fade>
                <Container maxWidth='lg' className='section' id='part2'>
                  <Title
                    h2='Part 2'
                    h3='Children and youth in internal displacement'
                  ></Title>
                  <p>
                    Around 25.2 million of the world's IDPs are under the age of
                    18 and the effects of their displacement go well beyond
                    their immediate safety, wellbeing and education. A healthy
                    and happy child is more likely to contribute to an equitable
                    society and a functioning economy.
                  </p>
                  <p>
                    More data is needed to better understand these broader and
                    longer-term impacts, but it is clear that protecting and
                    supporting displaced children and young people not only
                    safeguards their rights, but also contributes to a more
                    stable future for all.{' '}
                  </p>
                </Container>
                <Container >
                  <Interactive
                    svg={map_youth_svg}
                    png={map_youth}
                    id='idpyouth'
                    tooltip_id='youthtooltip'
                    dld={map_youth_dld}
                    caption='Total number of internally displaced children by conflict, violence and disasters as of 31 December 2021'
                    alt='Total number of internally displaced children by conflict, violence and disasters as of 31 December 2021'
                    interact='You can interact with this infographic to see in-depth data'
                    download='Download infographic'
                    name='Map - youth'
                    dropdown={[
                      "AFG",
                      "COD",
                      "COL",
                      "ETH",
                      "NGA",
                      "SDN",
                      "SOM",
                      "SSD",
                      "SYR",
                      "YEM"
                      ]}
                  />
                </Container>
                <Container maxWidth='lg'>
                  {/* <Title h4='Key Messages:' />
                <ul>
                  <li>
                    Of the nearly 60 million internally displaced people (IDPs),
                    25.2 million are children under the age of 18.
                  </li>
                  <li>
                    Protecting them from abuse and supporting their health,
                    wellbeing and education not only safeguards their rights,
                    but also contributes to a more stable future for all.
                  </li>
                  <li>
                    Displacement’s impacts on children and youth are not felt
                    equally, and they vary by individual, family and community.
                    Neither are they felt only locally or in the moment, they
                    have wider repercussions for years to come.
                  </li>
                </ul> */}
                  <p>
                    <DownloadPub name='part2' suffix='Download' />
                  </p>
                  <Title h4='Conclusion' />
                  <p>The number of people living in internal displacement worldwide has reached an all-time high. The unprecedented figures presented in this report are fuelled by both new and protracted conflicts, particularly in Africa and the Middle East. Millions more have fled their homes in Europe in recent months as the war in Ukraine evolves into the largest displacement crisis in the world. Disaster displacement continues to represent a significant global challenge with its impacts being felt in every corner of the world</p>
                  <p>Behind the data are millions of lives disrupted, communities torn apart, and children deprived of their future. The impacts of displacement not only place a heavy toll on children today, but also on future generations. We must look beyond the direct and immediate consequences on young people to better understand how these are connected to longer-term impacts on communities and societies. In the meantime, recognising children and youth as agents of change is vital to protecting development gains and reducing the risk of future displacement.</p>
                  <p>
                    <DownloadPub name='conclusion' suffix='Download' />
                  </p>
                </Container>
              </Fade>
              {/* <HeroQuote
                imageUrl={Quote5}
                id='quote-5'
                txtColor='#ffffff'
                bgColor='#0a3758'
                bgOpacity='0'
                copyright='The owner of the house closest to the Cumbre Vieja Volcano that erupted in La Palma, Canary Islands, Spain in February cleans up the surroundings of his house. © Kike Rincon/Europa Press via Getty Images, February 2022.'
              ></HeroQuote> */}
              
              
            </>
            <HeroVideos
                imageUrl={Quote7}
                id='quote-7'
                txtColor='#ffffff'
                bgColor='#0a3758'
                bgOpacity='0.8'
                copyright=''
              ><Container><Title h4='In their own words'></Title>
                <div className=' row'>
                  <div className='col-md-4'>
                  <YouTubeVideo youtubeId='v4skVdMYBEE' />
                  <p style={{ color: '#ffffff'}}>Jan Egeland, Secretary general, NRC</p>
                  </div>
                  <div className='col-md-4'>
                  <YouTubeVideo youtubeId='Qj6qmxbci9I' /><p style={{ color: '#ffffff'}}>Christelle Cazabat, IDMC</p>
                  </div>
                  <div className='col-md-4'>
                  <YouTubeVideo youtubeId='q3p80WzGero' /><p style={{ color: '#ffffff'}}>Farishta Afzaly, Youth advocate</p>
                  </div>
                </div></Container>
                </HeroVideos  >
            <>
              <Container id='download' maxWidth='lg' className='my-3'>
                <Title h4='Downloads'></Title><div className="row">
                  <div className='col-md-6'>
                  <Fade left>
                    <img src={cover3d} alt='GRID2022 cover' />
                    </Fade>
                  </div>
                  <div className="col-md-6">
                <Fade right>
                  <p>
                    <DownloadPub name='fullreport'></DownloadPub>
                  </p>
                  <p>
                    <DownloadPub name='fullreporthigh'></DownloadPub>
                  </p>
                  <div className='border p-3 mb-5'>
                    <p>Or select a section</p>
                    <SelectReport
                      options={[
                        {
                          label: `${PubData['foreword'][0]}`,
                          value: 'foreword'
                        },
                        {
                          label: '----------------------',
                          value: '',
                          isDisabled: true
                        },
                        {
                          label: `${PubData['part1'][0]}`,
                          value: 'part1'
                        },
                        {
                          label: '----------------------',
                          value: '',
                          isDisabled: true
                        },
                        {
                          label: 'Regional Overviews',
                          options: [
                            {
                              label: `${PubData['ssa'][0]}`,
                              value: 'ssa'
                            },
                            {
                              label: `${PubData['mena'][0]}`,
                              value: 'mena'
                            },
                            {
                              label: `${PubData['eap'][0]}`,
                              value: 'eap'
                            },
                            {
                              label: `${PubData['sa'][0]}`,
                              value: 'sa'
                            },
                            {
                              label: `${PubData['am'][0]}`,
                              value: 'am'
                            },
                            {
                              label: `${PubData['eca'][0]}`,
                              value: 'eca'
                            }
                          ]
                        },
                        {
                          label: 'Spotlights',
                          options: [
                            {
                              label: `${PubData['ssa-eth'][0]}`,
                              value: 'ssa-eth'
                            },
                            {
                              label: `${PubData['ssa-sdn'][0]}`,
                              value: 'ssa-sdn'
                            },
                            {
                              label: `${PubData['mena-pal'][0]}`,
                              value: 'mena-pal'
                            },
                            {
                              label: `${PubData['eap-chn'][0]}`,
                              value: 'eap-chn'
                            },
                            {
                              label: `${PubData['eap-mmr'][0]}`,
                              value: 'eap-mmr'
                            },
                            {
                              label: `${PubData['eap-png'][0]}`,
                              value: 'eap-png'
                            },
                            {
                              label: `${PubData['sa-afg'][0]}`,
                              value: 'sa-afg'
                            },
                            {
                              label: `${PubData['am-hai'][0]}`,
                              value: 'am-hai'
                            },
                            {
                              label: `${PubData['eca-ca'][0]}`,
                              value: 'eca-ca'
                            },
                            {
                              label: `${PubData['eca-wa'][0]}`,
                              value: 'eca-wa'
                            }
                          ]
                        },
                        {
                          label: '----------------------',
                          value: '',
                          isDisabled: true
                        },
                        {
                          label: `${PubData['part2'][0]}`,
                          value: 'part2'
                        },
                        {
                          label: `${PubData['conclusion'][0]}`,
                          value: 'conclusion'
                        },
                        {
                          label: `${PubData['figures'][0]}`,
                          value: 'figures'
                        }
                      ]}
                      action='View'
                    ></SelectReport>
                  </div>
                  <>
                    <div className='border p-3 mb-5'>
                      <p>Background Papers</p>
                      <SelectReport
                        options={[
                          {
                            label: `${PubData['bg-unesco-iiep'][0]}`,
                            value: 'bg-unesco-iiep'
                          },
                          {
                            label: `${PubData['bg-save-1'][0]}`,
                            value: 'bg-save-1'
                          },
                          {
                            label: `${PubData['bg-save-2'][0]}`,
                            value: 'bg-save-2'
                          },
                          {
                            label: `${PubData['bg-plan-int'][0]}`,
                            value: 'bg-plan-int'
                          },
                          {
                            label: `${PubData['bg-jips'][0]}`,
                            value: 'bg-jips'
                          },
                          {
                            label: `${PubData['bg-iom-unicef'][0]}`,
                            value: 'bg-iom-unicef'
                          },
                          {
                            label: `${PubData['bg-impact'][0]}`,
                            value: 'bg-impact'
                          }
                        ]}
                        action='Download'
                      ></SelectReport>
                    </div>
                  </>
                  <>
                    <p>
                      Country Figures{' '}
                      <Tooltip title='Information on the sources of our figures, as well as methodologies and caveats for some of the countries most affected by internal displacement. For any additional information contact us at info@idmc.ch'>
                        <InfoOutlinedIcon></InfoOutlinedIcon>
                      </Tooltip>{' '}
                    </p>
                    <SelectReport
                      options={countrylistoptions}
                      action='Download conflict figure analysis for'
                    ></SelectReport>
                  </>
                </Fade></div></div>
              </Container>
            </>
            <HeroVideos
                imageUrl={Quote8}
                id='quote-8'
                txtColor='#ffffff'
                bgColor='#0a3758'
                bgOpacity='0.8'
                copyright=''
              ><Container><Title h4='Launch of GRID 2022'></Title>
                <div className=' row'>
                  <div className='col-md-4'>
                  <YouTubeVideo youtubeId='Dtim9Jbt_M0' />
                  <p style={{ color: '#ffffff'}}>Launch of GRID 2022: high-level segment</p>
                  </div>
                  <div className='col-md-4'>
                  <YouTubeVideo youtubeId='i0YBwn8XgMY' /><p style={{ color: '#ffffff'}}>Launch of GRID 2022: technical segment</p>
                  </div>
                  <div className='col-md-4'>
                  <YouTubeVideo youtubeId='BlOm0h7i_jI' /><p style={{ color: '#ffffff'}}>Launch of GRID 2022: technical segment</p>
                  </div>
                </div></Container>
                </HeroVideos  >
          <Container
            maxWidth={false}
            className='py-3'
            style={{ backgroundColor: '#dee2e6' }}
          >
            <Container id='mediapack' maxWidth='lg' className='my-3'>
              <Title h4='Media Pack'></Title>
              <Accordion>
                <AccordionSummary
                  expandIcon={<ExpandMoreIcon />}
                  aria-controls='panel1a-content'
                  id='panel1a-header'
                >
                  <Typography>Download Press Release</Typography>
                </AccordionSummary>
                <AccordionDetails>
                <p> <PictureAsPdfIconOutlined> </PictureAsPdfIconOutlined> {' '}
                    <a href='https://www.internal-displacement.org/sites/default/files/IDMC_GRID22_PressRelease_ARA.pdf
'>Arabic</a> |{' '} 
                    <a href='https://www.internal-displacement.org/sites/default/files/IDMC_GRID22_PressRelease_EN.pdf
'>English</a> |{' '}
                    <a href='https://www.internal-displacement.org/sites/default/files/IDMC_GRID22_PressRelease_FR.pdf
'>French</a> |{' '}
                    <a href='https://www.internal-displacement.org/sites/default/files/IDMC_GRID22_PressRelease_DE.pdf
'>German</a> |{' '}
                    <a href='https://www.internal-displacement.org/sites/default/files/IDMC_GRID22_PressRelease_NOR.pdf
'>Norwegian</a> |{' '}
<a href='https://www.internal-displacement.org/sites/default/files/IDMC_GRID22_PressRelease_Russian.pdf
'>Russian</a> |{' '}
                    <a href='https://www.internal-displacement.org/sites/default/files/IDMC_GRID22_PressRelease_ES.pdf
'>Spanish</a> |{' '}
                    <a href='https://www.internal-displacement.org/sites/default/files/IDMC_GRID22_PressRelease_SWE.pdf'>Swedish</a> 
                  </p>
                </AccordionDetails>
              </Accordion>
              <Accordion>
                <AccordionSummary
                  expandIcon={<ExpandMoreIcon />}
                  aria-controls='panel2a-content'
                  id='panel2a-header'
                >
                  <Typography>Biography of spokespeople</Typography>
                </AccordionSummary>
                <AccordionDetails>
                  <div className='row'>
                    <div className='col-md-4'>
                      <ShowModal
                        img={Alexandra}
                        name='Alexandra Bilak'
                        title='Director of the Internal Displacement Monitoring Centre'
                      >
                        <p>
                          Alexandra Bilak has almost 20 years’ experience in the
                          international non-profit sector, with a focus on
                          research and policy development on displacement in the
                          context of armed conflict, violence, disasters and
                          climate change. She joined the Internal Displacement
                          Monitoring Centre in Geneva as Head of Policy and
                          Research in 2014, where she directed the first
                          publication of IDMC’s flagship report the Global
                          Report on Internal Displacement (GRID), becoming its
                          Director in August 2016.
                        </p>
                        <p>
                          Prior to joining IDMC, Alexandra spent a decade
                          working in sub-Saharan Africa for international NGOs
                          and research institutes, including Oxfam, the Life &
                          Peace Institute, the International Rescue Committee
                          and the Danish Refugee Council. She lived and worked
                          in Rwanda in 2001, the Democratic Republic of Congo
                          from 2004 to 2008, and in Kenya from 2009 to 2014. She
                          has published extensively on the themes of forced
                          displacement, conflict and civil society development.
                        </p>
                        <p>
                          Alexandra holds a Master's degree in International
                          Politics from the School of Oriental and African
                          Studies in London and a DEA (Diplôme d’Études
                          Approfondies) in African Studies and Political Science
                          from the University of Paris I Panthéon-Sorbonne. She
                          is bilingual French-English.
                        </p>
                      </ShowModal>
                    </div>
                    <div className='col-md-4'>
                      <ShowModal
                        img={Jan}
                        name='Jan Engeland'
                        title='Secretary General of the Norwegian Refugee Council
                    '
                        id='jan'
                      >
                        <p>
                          Jan Egeland is Secretary General of the Norwegian
                          Refugee Council (NRC). In September 2015, Egeland was
                          appointed by the UN Secretary-General as Special
                          Adviser to the UN Special Envoy for Syria with a focus
                          on humanitarian access and protection of civilians. He
                          ended this role in December 2018.
                        </p>
                        <p>
                          From 2003-2006, Egeland served as UN
                          Under-Secretary-General for Humanitarian Affairs and
                          Emergency Relief Coordinator. Before taking up his
                          post in NRC in 2013, Egeland came from the position as
                          Europe Director of Human Rights Watch (2011−2013), and
                          prior to that as Executive Director of the Norwegian
                          Institute of International Affairs (2007−2011).
                        </p>
                        <p>
                          He has also served as the UN Secretary General’s
                          Special Adviser to Colombia (1999−2001) and State
                          Secretary in the Norwegian Ministry of Foreign Affairs
                          (1990−1997). In 2006, Time Magazine named Egeland as
                          one of the ‘100 people who shape our world’.
                        </p>
                      </ShowModal>
                    </div>
                    <div className='col-md-4'>
                      <ShowModal
                        img={Bina}
                        name='Bina Desai'
                        title='Head of Policy and Research at IDMC
                    '
                        id='bina'
                      >
                        <p>
                          Bina has extensive programme and research experience
                          on socio-economic development in low income countries.
                          Having previously worked in Bangladesh, Ghana,
                          Honduras, India, Kenya, Malawi, Mozambique and the
                          Philippines, her research interests include the
                          structural causes of crises, economic and development
                          impacts of disaster and conflict, internal
                          displacement and forced migration.
                        </p>

                        <p>
                          She has worked for the German Ministry for
                          Development, the Aga Khan Development Network,
                          Christian Aid and the United Nations Office for
                          Disaster Risk Reduction (UNISDR).
                        </p>
                        <p>
                          In 2017, Bina joined IDMC as the Head of Policy &amp;
                          Research and leads IDMC's team of senior advisors and
                          researchers in displacement-related policy analysis
                          and evidence building. Bina holds a Masters in
                          Economics and Sociology from the University of
                          Bielefeld and a PhD in Social Anthropology from the
                          School of Oriental and African Studies in London.
                        </p>
                      </ShowModal>
                    </div>
                    <div className='col-md-4'>
                      <ShowModal
                        img={Vicente}
                        name='Vicente Anzellini'
                        title='GRID coordinator at IDMC
                    '
                        id='bina'
                      >
                        <p>
                          Vicente leads the global and regional analysis team at
                          IDMC and coordinates the production of the Global
                          Report on Internal Displacement (GRID), working
                          closely with all departments for the development of
                          IDMC’s flagship report on internal displacement.
                        </p>

                        <p>
                          He previously worked at UNISDR, where he worked on a
                          global policy review exercise that formed the basis
                          for national policy indicators for the Sendai
                          Framework, as well as coordinating research and
                          country programmes, developing disaster loss and
                          damage data and analysis, and government capacity
                          building on risk knowledge at national and regional
                          levels. He worked in a number of countries across
                          Africa, Central and Southern Asia, and the Pacific.
                        </p>

                        <p>
                          Vicente holds a BA in History and Geography from the
                          University of Los Andes (Bogotá, Colombia) and a MA in
                          Human Geography and Migration Studies from the
                          University of Neuchâtel (Switzerland). He speaks
                          Spanish, French and English.
                        </p>
                      </ShowModal>
                    </div>
                    <div className='col-md-4'>
                      <ShowModal
                        img={Vincent}
                        name='Vincent Fung'
                        title='Regional Coordinator, Asia and the Pacific'
                        id='vincent'
                      >
                        <p>
                          Vincent is a Regional Coordinator at IDMC, he focuses
                          on monitoring and research on displacement in the Asia
                          Pacific region. Vincent joined IDMC in 2016 as a
                          monitoring expert for the Data and Analysis
                          Department.
                        </p>

                        <p>
                          With over 15 years of experience consulting on data
                          analysis, information management and visual
                          communications, Vincent has been involved in issues
                          ranging from public health, urban issues, humanitarian
                          response, to disaster risk reduction. He has been a
                          data and digital communications guru, trainer and
                          designer for the UN in Switzerland, served as an
                          information management advisor to the Humanitarian
                          Coordinator in Timor-Leste, and also provided
                          expertise on spatial analysis and mapping for UNOCHA
                          in the Asia and the Pacific region. Vincent has also
                          consulted on similar projects for UNDP in South East
                          Asia, health NGOs in the Balkans, and local and
                          federal governments in Canada.
                        </p>

                        <p>
                          Vincent is a geographer and holds a Master’s in
                          International Urban and Environmental Management from
                          RMIT University with a focus on behavioral studies. He
                          speaks English, French, and Cantonese and has basic
                          knowledge of Japanese and Thai.
                        </p>
                      </ShowModal>
                    </div>
                    <div className='col-md-4'>
                      <ShowModal
                        img={Ivana}
                        name='Ivana Hajzmanova'
                        title='Regional Coordinator, MENA and Sub-Saharan Africa'
                        id='ivana'
                      >
                        <p>
                          Ivana is a Regional Coordinator at IDMC, she focuses
                          on monitoring and research on displacement in the
                          Middle East and Africa. She joined IDMC in 2016,
                          bringing experience in humanitarian needs and conflict
                          analysis. Ivana has a background in humanitarian and
                          human rights law and she previously worked on
                          humanitarian needs analysis and assessment, and human
                          rights advocacy with national and international NGOs.
                        </p>

                        <p>
                          Ivana holds Master’s degree in Human Rights and
                          Humanitarian Action from Sciences Po Paris and spent
                          one semester studying international law and history of
                          violence at the Graduate Institute of International
                          and Development Studies in Geneva.
                        </p>

                        <p>
                          Ivana is fluent in English, French, Spanish, and
                          Czech. She can also communicate in Arabic.
                        </p>
                      </ShowModal>
                    </div>
                    <div className='col-md-4'>
                    <ShowModal
                        img={Ricardo}
                        name='Ricardo Fal-Dutra Santos'
                        title='Regional Coordinator for Americas, Europe, Caucasus and Central Asia'
                        id='ricardo'
                      >
                        <p>
                        Ricardo Fal-Dutra Santos joined us as Regional Coordinator for Americas, Europe, Caucasus and Central Asia. He has over seven years of experience leading humanitarian research and responses, notably in the area of protection, in Angola, Jordan, Mozambique, Nigeria, Palestine, South Africa and South Sudan. He has also worked in the headquarters of the International Committee of the Red Cross and Oxfam, supporting country teams in wide range of countries.
                        </p>

                        <p>
                        Ricardo holds a master's degree in International Security from Sciences Po (Paris, France) and a BA in History from the Fluminense Federal University (Niterói, Brazil). He speaks English, French, Portuguese and Spanish.
                        </p>
                      </ShowModal>
                    </div>
                  </div>
                </AccordionDetails>
              </Accordion>
              <Accordion>
                <AccordionSummary
                  expandIcon={<ExpandMoreIcon />}
                  aria-controls='panel3a-content'
                  id='panel3a-header'
                >
                  <Typography> Media Photos / B-Roll</Typography>
                </AccordionSummary>
                <AccordionDetails>
                  <p><a href="https://www.internal-displacement.org/sites/default/files/grid2022-broll.zip">B-roll (Zip folder | 578Mb)</a></p>
                </AccordionDetails>
              </Accordion>
              <Accordion>
                <AccordionSummary
                  expandIcon={<ExpandMoreIcon />}
                  aria-controls='panel4a-content'
                  id='panel4a-header'
                >
                  <Typography> Infographics</Typography>
                </AccordionSummary>
                <AccordionDetails>
                  <div className='row'>
                    <ShowModalInfog
                      img={map_global_dld}
                      id='infographic-globalmap'
                      name='Global map'
                    ></ShowModalInfog>
                    <ShowModalInfog
                      img={SpiralDld}
                      id='infographic-spiral'
                      name='Spiral'
                    ></ShowModalInfog>

                    <ShowModalInfog
                      img={BreakddownDld}
                      id='infographic-breakdown'
                      name='breakdown'
                    ></ShowModalInfog>
                    <ShowModalInfog
                      img={map_conflict_dld}
                      id='infographic-map-conflict'
                      name='Map - conflict'
                    ></ShowModalInfog>
                    <ShowModalInfog
                      img={map_disasters_dld}
                      id='infographic-map-disasters'
                      name='Map - disasters'
                    ></ShowModalInfog>
                    <ShowModalInfog
                      img={map_youth_dld}
                      id='infographic-map-youth'
                      name='Map - youth'
                    ></ShowModalInfog>
                    <ShowModalInfog
                      img={read_data_conflict}
                      id='read_data_conflict'
                      name='How to read data - conflict and violence'
                    ></ShowModalInfog>
                    <ShowModalInfog
                      img={read_data_disasters}
                      id='read_data_disasters'
                      name='How to read data - disasters'
                    ></ShowModalInfog>
                  </div>
                </AccordionDetails>
              </Accordion>
            </Container>
          </Container>

          <Footer
            imageUrl={gridhero}
            txtColor='#ffffff'
            bgColor='#0a3758'
            bgOpacity='0.3'
          />
        </div>
        </div>
      </main>
    </>
  )
  //const launchTime = new Date(Date.UTC(2022, 4, 19, 4, 0, 0));
  //const launchTime = new Date(Date.UTC(2022, 4, 18, 10, 27, 0));
  // const timeNow = new Date();
  // let isTest = false 
  // if (typeof window !== 'undefined'){
  // const queryParams = new URLSearchParams(window.location.search)
  //  isTest = queryParams.get("test")}
  
  // const formattedDate= date =>{
    
  //   if (launchTime <= timeNow || isTest ){
  //   return indexContent} else {
  //   return comingsoonContent }
  // }
  //return formattedDate(launchTime)

}

// export const query = graphql`
//   query {
//     part1: mdx(slug: { eq: "english-part1" }) {
//       frontmatter {
//         h2
//         h3
//         graph1_caption
//       }
//     }
//     general: mdx(slug: { eq: "generic-english" }) {
//       frontmatter {
//         interact
//         download
//       }
//     }
//   }
// `


export default IndexPageDev
